<template>
<div style="position:relative">
  <textarea
    class="autotextarea"
    ref="textarea"
    style="min-height:3rem;overflow-y:hidden;"
    @input="text_input"
    v-model="text"
    :placeholder="placeholder"
    :disabled="disabled"
    :maxlength="textmax"
  >
  </textarea>
  <span
    class="autotextcount">
    {{textmax - text.length}} left
  </span>
</div>
</template>

<script>

export default {
  name: "AutoTextArea",
  props: ["value","maxlength","placeholder","disabled"],
  components: {
  },
  watch: {
    value: function(to,from) {
      this.value_changed(to);
    },
  },
  data() {
    return  {
       user_input: false,
       text: "",
       textmax: 10,
    };
  },
  computed: {
  },
  mounted: function() {
    let vue = this;
    vue.user_input = false;
    vue.textmax = vue.maxlength || 10;
    vue.value_changed(vue.value);
  },
  methods: {
    value_changed: function(value) {
      let vue = this;
      let ta = vue.$refs.textarea;
      /* Set changed specified value */
      vue.text = value || "";
      /* This is to handle programmatic variable setting; Skip once
         user input has occurred. */
      if (vue.user_input) { return; }
      /* Trigger delayed call so cell can compute */
      setTimeout(function() { vue.text_input({target:ta}); }, 1);
      return;
      //if (ta) {
      //   let px = getComputedStyle(ta).fontSize;
      //   let px_per_char = 0|(px.match(/(\d+)/)[1]);
      //   let lines = vue.text.split("\n").length;
      //   /* lines * px_per_char * 1.1 lineheight + px_per_char * padding */
      //   ta.style.height = ((px_per_char*lines*1.1)+(px_per_char*0.4))+"px";
      //   console.log("height1:"+px_per_char+","+lines+","+ta.style.height);
      //}
    },
    text_input: function(ev) {
       let vue = this;
       vue.user_input = true;
       if (ev.target.scrollHeight) {
         ev.target.style.height = ev.target.scrollHeight+"px";
       } else {
         ev.target.style.height = "auto";
       }
       //console.log("height2:"+ev.target.style.height);
       vue.$emit("input",vue.text);
    }
  },
}
</script>

<style lang="scss" scoped>
.autotextarea {
  /*font-size: 1rem;*/
  /*line-height: 1.1rem;*/
  padding:0.2rem;
  width:100%;
}

.autotextcount {
  position: absolute;
  color:red;
  font-size: 0.6rem;
  font-weight: bold;
  right: 1rem;
  bottom: 0.5rem;
}
</style>